import PropTypes from 'prop-types';
import contextTypes from './contextTypes';

export default { ...contextTypes, header: PropTypes.bool };
